module.exports = __webpack_public_path__ + "img/frame (197).52da5b28.jpg";